function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "rewards/goals-400");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 44.9999648 0 44.9999648 47.9999652 0 47.9999652"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0 0 44.9999648 0 44.9999648 44.5217043 0 44.5217043"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-5",
  points: "0 0 44.9999648 0 44.9999648 44.5217043 0 44.5217043"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-7",
  points: "-3.515625e-05 0 22.4999648 0 22.4999648 47.9999652 -3.515625e-05 47.9999652"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Product",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard-Rewards-1440",
  transform: "translate(-1006.000000, -681.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "rewards/goals-400",
  transform: "translate(1006.000000, 681.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-15"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.4999648,47.9999652 L22.4999648,47.9999652 C10.0736367,47.9999652 -3.515625e-05,38.0333565 -3.515625e-05,25.7390957 L-3.515625e-05,4.17387826 C-3.515625e-05,1.86883478 1.88891016,-3.47826087e-05 4.21871484,-3.47826087e-05 L40.7812148,-3.47826087e-05 C43.1110195,-3.47826087e-05 44.9999648,1.86883478 44.9999648,4.17387826 L44.9999648,25.7390957 C44.9999648,38.0333565 34.926293,47.9999652 22.4999648,47.9999652",
  id: "Fill-1",
  fill: "#128184",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.4999648,44.5217043 L22.4999648,44.5217043 C10.0736367,44.5217043 -3.515625e-05,34.5550957 -3.515625e-05,22.2608348 L-3.515625e-05,4.17387826 C-3.515625e-05,1.86883478 1.88891016,-3.47826087e-05 4.21871484,-3.47826087e-05 L40.7812148,-3.47826087e-05 C43.1110195,-3.47826087e-05 44.9999648,1.86883478 44.9999648,4.17387826 L44.9999648,22.2608348 C44.9999648,34.5550957 34.926293,44.5217043 22.4999648,44.5217043",
  id: "Fill-4",
  fill: "#6FE2DC",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-9"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7812148,-3.47826087e-05 L4.21871484,-3.47826087e-05 C1.88891016,-3.47826087e-05 -3.515625e-05,1.86883478 -3.515625e-05,4.17387826 L-3.515625e-05,22.2608348 C-3.515625e-05,34.5550957 10.0736367,44.5217043 22.4999648,44.5217043 C34.926293,44.5217043 44.9999648,34.5550957 44.9999648,22.2608348 L44.9999648,4.17387826 C44.9999648,1.86883478 43.1110195,-3.47826087e-05 40.7812148,-3.47826087e-05 M40.7812148,4.17387826 L40.7812148,22.2608348 C40.7812148,32.2340522 32.5803164,40.3477913 22.4999648,40.3477913 C12.4196133,40.3477913 4.21871484,32.2340522 4.21871484,22.2608348 L4.21871484,4.17387826 L40.7812148,4.17387826",
  id: "Fill-7",
  fill: "#18ACB7",
  mask: "url(#mask-6)"
})), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-10",
  stroke: "#18ACB7",
  strokeWidth: 4.17391304,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  points: "32.2808906 14.937287 20.2890937 26.8019826 14.1251484 20.7038957"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-14",
  transform: "translate(22.500000, 0.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-8",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-7"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-13"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2812148,-3.47826087e-05 L-3.515625e-05,-3.47826087e-05 L-3.515625e-05,47.9999652 C12.426293,47.9999652 22.4999648,38.0333565 22.4999648,25.7390957 L22.4999648,4.17387826 C22.4999648,1.86883478 20.6110195,-3.47826087e-05 18.2812148,-3.47826087e-05",
  id: "Fill-12",
  fill: "#FFFFFF",
  opacity: 0.200000003,
  mask: "url(#mask-8)"
}))))));

var SvgGoals400 = function SvgGoals400(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoals400, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/goals-400.a104d9e6.svg";
export { ForwardRef as ReactComponent };